// src/hooks/useLevelCountdownBeep.ts
import { useEffect, useRef } from "react";
import { playBeep } from "../utils/sound";

/**
 * Piept bei den letzten 5 Sekunden (5..1) eines Levels jeweils einmal.
 * Der letzte Beep (1 Sekunde) ist etwas länger und höher.
 */
export function useLevelCountdownBeep(
    timeLeft: number,
    levelIndex: number,
    enabled: boolean = true
) {
    const playedSecondsRef = useRef<Set<number>>(new Set());
    const lastLevelRef = useRef<number>(levelIndex);

    useEffect(() => {
        // Levelwechsel -> Reset der bereits gespielten Beeps
        if (levelIndex !== lastLevelRef.current) {
            playedSecondsRef.current = new Set();
            lastLevelRef.current = levelIndex;
        }
    }, [levelIndex]);

    useEffect(() => {
        if (!enabled) return;
        if (timeLeft <= 0) return;

        if (timeLeft <= 5 && timeLeft >= 1) {
            if (!playedSecondsRef.current.has(timeLeft)) {
                const freqMap: Record<number, number> = {
                    5: 800,
                    4: 800,
                    3: 800,
                    2: 800,
                    1: 1200,
                };

                const freq = freqMap[timeLeft] ?? 800;
                const duration = timeLeft === 1 ? 300 : 140;
                const volume = timeLeft === 1 ? 0.3 : 0.25;

                playBeep(freq, duration, volume);
                playedSecondsRef.current.add(timeLeft);
            }
        }
    }, [timeLeft, enabled]);
}
